import { Field, InputType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import type { EntityMeta } from '../../base/EntityMeta'
import type { FilterQuery } from '../../repository/types'
import type { User } from '../User'

@InputType()
export class GetUsersMetaArgs extends ActionArgs {
  @Field(() => GraphQLJSON, { nullable: true })
  filter?: FilterQuery<User>
}

export interface IGetUsersMeta extends IAction<EntityMeta, GetUsersMetaArgs> {}
